import { Box } from '@mui/material';
import { BarController, BarElement, CategoryScale, Chart, Legend, LinearScale, Title, Tooltip, } from 'chart.js';
import merge from 'lodash/merge';
import React, { forwardRef } from 'react';
import { Bar } from 'react-chartjs-2';
Chart.register(Title, Tooltip, Legend, CategoryScale, LinearScale, BarElement, BarController);
export const BarChart = forwardRef(({ data, options, containerProps }, ref) => {
    const defaultOptions = merge({
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
                position: 'bottom',
                align: 'center',
            },
            title: {
                display: false,
                text: '',
            },
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                }, //
            }, //
            y: {
                stacked: true,
                grid: {
                    display: false,
                },
            },
        },
        elements: {
            bar: {
                borderRadius: 6,
            },
        },
    }, options);
    const defaultContainerProps = merge({
        component: 'div',
        sx: {
            minWidth: 0,
            width: '100%',
            height: '100%',
        },
    }, containerProps);
    return (React.createElement(Box, { ...defaultContainerProps },
        React.createElement(Bar, { data: data, ref: ref, redraw: true, options: defaultOptions })));
});
